import React, { useState, useEffect, useRef } from "react";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import constants from "../../../constants";
import TableDropdownAndPagination from "../../../services/TableDropdownAndPagination";
import { checkIfFileIsaDocument } from "../../../services/FileOperationGlobalFunctions";
import GlobalViewFileModal from "../../../services/GlobalViewFileModal";
import { redirectUrl } from "../../../services/GlobalUrls";
import ExportButtons from "../SkeletonLoader/ExportButtons";
import TableNewPaginanation from "../../../services/TableNewPaginanation";

const TimeSheetsList = (props) => {
  const [timesheets, SetTimeSheets] = useState([]);
  const [recordLen, setRecordLen] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [dataLen, setDataLen] = useState(0);
  const [filter, setFilter] = useState("");
  const [modalOption, setModalOption] = useState(false);
  const [modalHeight, setModalHeight] = useState("500px");
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  let totalPages = Math.ceil(dataLen / recordsPerPage);
  let startIndex = (currentPage - 1) * recordsPerPage;
  let endIndex = Math.min(startIndex + recordsPerPage, dataLen);

  useEffect(() => {
    const lenOfData = props.timesheets.length;
    setDataLen(lenOfData);
    totalPages = Math.ceil(lenOfData / recordsPerPage);
    startIndex = (currentPage - 1) * recordsPerPage;
    endIndex = Math.min(startIndex + recordsPerPage, lenOfData);
    SetTimeSheets(props.timesheets);
  }, [props.timesheets]);

  // const handleLeft = () => {
  //   setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  // };

  // const handleRight = () => {
  //   setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  // };

  // const visiblePages = 4;

  // const renderPageNumbers = () => {
  //   const pageNumbers = [];
  //   let startPage = currentPage - Math.floor(visiblePages / 2);
  //   let endPage = currentPage + Math.floor(visiblePages / 2);

  //   if (startPage < 1) {
  //     startPage = 1;
  //     endPage = Math.min(totalPages, visiblePages);
  //   }

  //   if (endPage > totalPages) {
  //     endPage = totalPages;
  //     startPage = Math.max(1, totalPages - visiblePages + 1);
  //   }

  //   for (let i = startPage; i <= endPage; i++) {
  //     pageNumbers.push(
  //       <li
  //         key={i}
  //         className={i === currentPage ? "active" : ""}
  //         onClick={() => {
  //           setCurrentPage(i);
  //           setFilter("");
  //         }}
  //       >
  //         <Link to="#">{i}</Link>
  //       </li>
  //     );
  //   }

  //   return pageNumbers;
  // };

  // const handleDropDown = (value) => {
  //   setRecordLen(value);
  //   setRecordsPerPage(value);
  //   setCurrentPage(1);
  // };

  const handlePageChange = (page, pageSize = recordsPerPage) => {
    setCurrentPage(page);
    setRecordsPerPage(pageSize === "all" ? dataLen : pageSize);
  };

  const prepareTimesheetExportData = (data) => {
  if (!data || data.length === 0) return [];

  return data.map((ts, index) => ({
    "Sr.No.": index + 1,
    "Date & Time": ts.cnd_timesheet_created_date || "-",
    Name: ts.fullname || "-",
    "Client Name": ts.cnd_timesheet_client_name || "-",
    "Week Commencing": ts.cnd_timesheet_week_commencing || "-",
    Status: ts.cnd_timesheet_status || "-",
  }));
};

const exportData = React.useMemo(() => {
  return prepareTimesheetExportData(timesheets);
}, [timesheets]);

  const viewFileModal = (url, fileName) => {
    if (checkIfFileIsaDocument(url)) {
      setModalHeight("500px");
      setFileUrl(url);
      setFileName(fileName);
    } else {
      redirectUrl(url);
    }
  };

  const callModal = () => {
    document.getElementById("loader").style.display = "block";
    setModalOption(true);
  };
  const loaderEnd = () => {
    document.getElementById("loader").style.display = "none";
    setModalHeight("auto");
  };

  const closeFileModal = () => {
    setModalOption(false);
    setFileUrl("");
  };

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        {/* Search Start */}
      <div className="container">
  <div className="row align-items-center mb-3">

    {/* LEFT – Export Buttons */}
    <div className="col-sm-6 d-flex align-items-center">
      {/* <ExportButtons
        data={exportData}
        fileName="Timesheets_List"
        buttons={true}
      /> */}
    </div>

    {/* RIGHT – Search */}
    <div className="col-sm-6 d-flex justify-content-end">
      <input
        type="text"
        name="search"
        className="form-control"
        placeholder="Search here"
        style={{ height: "40px", width: "200px" }}
        id="myInput"
      />
    </div>

  </div>
</div>
{/* Search End */}
        {/* Search End */}
        <div className="courses-section">
          <table className="courses-table">
          <thead className="thead-dark">
            <tr>
              {/*<th  className="col-1 text-center" scope="col">Sr. No</th>*/}
              <th className="col-1 text-center" scope="col">
                Date & Time
              </th>
              <th className="col-3 text-center" scope="col">
                {" "}
                Name
              </th>
              {/*<th  className="col-2 text-center" scope="col">Email</th>*/}
              <th className="col-2 text-center" scope="col">
                Client Name
              </th>
              <th className="col-2 text-center" scope="col">
                Week Commencing
              </th>
              <th className="col-3 text-center" scope="col">
                Uploaded Timesheet
              </th>
              <th className="col-1 text-center" scope="col">
                Status
              </th>
              {/*<th  className="col-1 text-center" scope="col">Action</th>*/}
            </tr>
          </thead>
          <tbody id="myTable">
            {timesheets &&
              timesheets.length > 0 &&
              timesheets?.slice(startIndex, endIndex).map((timesheet, i) => (
                <tr key={i}>
                  {/*<td className="col-1 text-center" scope="row">
                    {i + 1}
              </td>*/}
                  <td className="col-4 text-center" scope="row">
                    {timesheet.cnd_timesheet_created_date}
                  </td>
                  <td className="col-3 text-center" scope="row">
                    {timesheet.fullname}
                  </td>
                  {/*<td  className="col-2" scope="col">{timesheet.users_email}</td>*/}
                  <td className="col-3 text-center" scope="row">
                    {timesheet.cnd_timesheet_client_name}
                  </td>
                  <td className="col-3 text-center" scope="row">
                    {timesheet.cnd_timesheet_week_commencing}
                  </td>
                  <td className="col-3 text-center" scope="col">
                    <a
                      rel="noopener noreferrer"
                      download
                      onClick={() =>
                        viewFileModal(
                          constants.IMAGE_URL +
                            timesheet.cnd_timesheet_folderpath +
                            timesheet.cnd_timesheet_upload_document
                        )
                      }
                      className={
                        "btn btn-" +
                        (timesheet.cnd_timesheet_upload_document.endsWith(
                          ".png"
                        ) ||
                        timesheet.cnd_timesheet_upload_document.endsWith(
                          ".jpg"
                        ) ||
                        timesheet.cnd_timesheet_upload_document.endsWith(
                          ".jpeg"
                        ) ||
                        timesheet.cnd_timesheet_upload_document.endsWith(".pdf")
                          ? "dark"
                          : "primary") +
                        " btn-sm text-white"
                      }
                    >
                      <i
                        className={
                          "fa fa-" +
                          (timesheet.cnd_timesheet_upload_document.endsWith(
                            ".png"
                          ) ||
                          timesheet.cnd_timesheet_upload_document.endsWith(
                            ".jpg"
                          ) ||
                          timesheet.cnd_timesheet_upload_document.endsWith(
                            ".jpeg"
                          ) ||
                          timesheet.cnd_timesheet_upload_document.endsWith(
                            ".pdf"
                          )
                            ? "eye" //"eye"
                            : "download")
                        }
                      ></i>
                    </a>
                  </td>
                  <td className="col-1 text-center" scope="col">
                    {" "}
                    {timesheet.cnd_timesheet_status}
                  </td>
                  {/*<td  className="col-1 text-center" scope="col"> <Link to={"/create-timesheet/"+timesheet.cnd_timesheet_id}><i className="fa fa-pencil"></i></Link></td>*/}
                </tr>
              ))}
            {timesheets.length == 0 && (
              <tr>
                <td colSpan="100">No timesheets Founds.</td>
              </tr>
            )}
          </tbody>
        </table>
        {timesheets && timesheets.length > 0 && (
         <TableNewPaginanation
            totalItems={dataLen}
            pageSize={recordsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            isDropdown={true}
            isPaggination={true}
          />
        )}
      </div>
      </div>
      <GlobalViewFileModal
        modalOption={modalOption}
        closeFileModal={closeFileModal}
        fileUrl={fileUrl}
        // fileName={fileName}
        loaderEnd={loaderEnd}
        modalHeight={modalHeight}
        callModal={callModal}
        title={"TimeSheet - Uploaded TimeSheet"}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    timesheets: state.timesheets.timesheets,
  };
};

export default connect(mapStateToProps)(TimeSheetsList);
